<template>
    <div>
        <b-modal
            id="modalReminderAddBundle"
            ref="modalReminderAddBundle"
            :scrollable="true"
            :lazy="true"
            title="New Reminder Bundle"
            title-tag="h2"
            no-close-on-backdrop
            content-class="overflow-visible"
            :body-class="page == 'ReminderAddBundle' ? 'overflow-visible' : ''"
        >
            <transition name="slide-fade">
                <reminder-add-bundle
                    ref="ReminderAddBundle"
                    v-if="page == 'ReminderAddBundle'"
                    :data="data"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class=""
                />
                <reminder-items
                    ref="ReminderItems"
                    v-if="page == 'ReminderItems'"
                    :data="data"
                    @loading="loading = true"
                    @loaded="loading = false"
                    @update-iscontinuesave="isContinueSave"
                    class=""
                />
                <reminder-type
                    ref="ReminderType"
                    v-if="page == 'ReminderType'"
                    :data="data"
                    @loading="loading = true"
                    @loaded="loading = false"
                    class=""
                />
            </transition>
            <div slot="modal-footer" class="w-100">
                <b-btn
                    @click="$refs.modalReminderAddBundle.hide()"
                    v-if="!loading"
                    class="float-left"
                    variant="secondary"
                    >Cancel</b-btn
                >
                <div v-if="loading" class="float-right">
                    <img v-if="loading" src="assets/ajax-loader.gif" />
                </div>
                <div v-else class="float-right">
                    <b-btn
                        @click="back"
                        v-if="page != 'ReminderAddBundle'"
                        variant="primary"
                        >Back</b-btn
                    >&nbsp;
                    <b-btn
                        @click="save"
                        v-if="
                            page == 'ReminderType' ||
                            (page == 'ReminderItems' && continueSave)
                        "
                        :disabled="data.items.length == 0"
                        variant="primary"
                        >Save</b-btn
                    >
                    <b-btn
                        @click="next"
                        v-else
                        :disabled="
                            page != 'ReminderAddBundle'
                                ? data.items.length == 0
                                : false
                        "
                        variant="primary"
                        >Next</b-btn
                    >
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { cloneDeep } from "lodash";
import ReminderAddBundle from "./reminder-add-bundle.vue";
import ReminderItems from "@/components/reminder-bundle/reminder-items";
import ReminderType from "@/components/reminder-bundle/reminder-type";
import CONSTANTS from "@/constants/history";
import { DateTime } from "luxon";
import Reminders from "@/services/reminders";

export default {
    components: {
        ReminderAddBundle,
        ReminderItems,
        ReminderType
    },
    props: {
        module: {
            type: String,
            required: true
        },
        patientId: {
            type: String
        },
        clientId: {
            type: String
        }
    },
    data() {
        return {
            page: "ReminderAddBundle",
            loading: false,
            data: {
                bundleId: [],
                items: [],
                itemOptions: [],
                patients: [],
                patientId: this.patientId,
                clientId: this.clientId,
                type: null,
                reminderType: null,
                reminderSend: null,
                reminderSendOption: null,
                reminderPeriod: null,
                note: "",
                module: this.module,
                isNew: "1"
            },
            continueSave: true
        };
    },
    computed: {},
    watch: {},
    methods: {
        async open() {
            this.page = "ReminderAddBundle";
            this.data.patientId = this.patientId;
            if (this.data.patientId != undefined) {
                this.data.patients = [this.data.patientId];
            }
            this.data.clientId = this.clientId;
            this.data.module = this.module;
            this.$refs.modalReminderAddBundle.show();
        },
        async save() {
            let self = this;
            let promise = true;
            if (self.page == "ReminderItems") {
                promise = await window.Promise.all(
                    this.$refs.ReminderItems.$children.map(function (child) {
                        return child.$validator.validateAll();
                    })
                );
                promise = !promise.includes(false);
            } else if (self.page == "ReminderType") {
                promise = await self.$refs.ReminderType.$validator.validateAll();
            }
            this.data.items = this.data.itemOptions.filter(item => {
                return item.selected;
            });
            if (promise && self.data.items.length > 0) {
                self.loading = true;

                let params = {
                    reminder_send: self.data.reminderSend
                        ? String(self.data.reminderSend)
                        : 2,
                    reminder_send_option: self.data.reminderSendOption
                        ? String(self.data.reminderSendOption)
                        : 1,
                    reminder_period: self.data.reminderPeriod
                        ? String(self.data.reminderPeriod)
                        : 4,
                    reminder_type_id: self.data.reminderType
                        ? String(self.data.reminderType)
                        : 4,
                    note: self.data.note,
                    module: "item",
                    items: [],
                    is_new: self.data.isNew,
                    is_client: self.data.module == "client"
                };

                if (self.data.module == "client") {
                    params.patients = [];
                    self.data.patients.forEach(patient => {
                        params.patients.push(patient.id);
                    });
                    params.client_id = self.data.clientId;
                } else {
                    params.patient_id = self.data.patientId;
                }

                self.data.items.forEach(item => {
                    params.items.push({
                        item_id: item.item_id,
                        start: item.givenDate
                            ? DateTime.fromFormat(
                                  item.givenDate,
                                  self._getLuxonFormat()
                              ).toSeconds()
                            : null,
                        due: DateTime.fromFormat(
                            item.dueDate,
                            self._getLuxonFormat()
                        ).toSeconds(),
                        has_reminder_action: item.has_reminder_action,
                        bundle_id: item.bundle_id
                    });
                });

                // save bundle process
                Reminders.saveReminderBundle(params)
                    .then(res => {
                        self.isLoading = false;
                        if (res.message && res.message.code === 200) {
                            self.$refs.modalReminderAddBundle.hide();
                            this._message(res.resource.message);
                            this.$emit("reload", CONSTANTS.VIEWS.RECORDS);
                        } else {
                            throw new Error(res.errors.message);
                        }
                    })
                    .catch(error => {
                        self.showError(error.message);
                        console.error(error);
                    })
                    .finally(() => {
                        self.loading = false;
                    });
            } else {
                self.loading = false;
            }
        },
        next() {
            let self = this;
            if (self.page == "ReminderAddBundle") {
                self.$refs.ReminderAddBundle.$validator
                    .validateAll()
                    .then((result, e) => {
                        if (result) {
                            self.page = "ReminderItems";
                            $(".modal-content").removeAttr("tabindex");
                        }
                    });
            } else if (self.page == "ReminderItems") {
                self.data.items = self.data.itemOptions.filter(item => {
                    return item.selected;
                });

                if (self.data.items.length > 0) {
                    this.data.items = cloneDeep(this.data.itemOptions);
                    var validationArray = this.$refs.ReminderItems.$children.map(
                        function (child) {
                            return child.$validator.validateAll();
                        }
                    );

                    window.Promise.all(validationArray).then((result, e) => {
                        if (!result.includes(false)) {
                            self.page = "ReminderType";

                            self.data.reminderType = 4;
                            self.data.reminderSend = null;
                            self.data.reminderSendOption = null;
                            self.data.reminderPeriod = null;

                            $(".modal-content").removeAttr("tabindex");
                        }
                    });
                }
            }
        },
        back() {
            if (this.page == "ReminderItems") {
                this.data.items = [];
                this.data.itemOptions = [];
                this.page = "ReminderAddBundle";
            } else if (this.page == "ReminderType") {
                this.page = "ReminderItems";
            }
        },
        isContinueSave(isContinueSave) {
            this.continueSave = isContinueSave;
        },
        showError(msg) {
            let defaultMessage = "Error : Unable to save reminder";
            this._message(msg || defaultMessage, "danger");
            this.$refs.modalReminderAddBundle.hide();
        }
    }
};
</script>
